import { Record } from "immutable";
import type { CodeReferenceBlockConfiguration } from "models/interfaces/block-configurations/code-reference-block-configuration";
import {
    BlockConfigurationRecord,
    blockConfigurationDefaultValuesFactory,
} from "models/view-models/block-configurations/block-configuration-record";
import { CodeReferenceBlockHighlightRecord } from "../code-reference-block-highlights/code-reference-block-highlight-record";
import { RecordUtils } from "@rsm-hcd/javascript-core";

const defaultValues: CodeReferenceBlockConfiguration =
    blockConfigurationDefaultValuesFactory<CodeReferenceBlockConfiguration>({
        sectionId: undefined,
        highlights: [],
        isEnhancedContentDisplayed: false,
    });

export class CodeReferenceBlockConfigurationRecord
    extends Record(defaultValues)
    implements CodeReferenceBlockConfiguration, BlockConfigurationRecord
{
    constructor(params?: Partial<CodeReferenceBlockConfiguration>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        if (params.highlights) {
            params.highlights = RecordUtils.ensureRecords(
                params.highlights,
                CodeReferenceBlockHighlightRecord
            );
        }

        super(params);
    }

    public with(
        values: Partial<CodeReferenceBlockConfiguration>
    ): CodeReferenceBlockConfigurationRecord {
        return new CodeReferenceBlockConfigurationRecord(
            Object.assign(this.toJS(), values)
        );
    }
}
